import * as types from '../../mutation-types'
import axios from "axios";

export const getUserWeek = async ({ commit }) => {
    try {
        const { data } = await axios.get(process.env.API_URL + '/get-user-week');
        commit(types.FETCH_USER_WEEK, { data })
    } catch (e) {
        commit(types.FETCH_USER_WEEK_FAILURE)
    }
}

export const saveRegimenCalendar = async ({ commit }, formData) => {
    try {
        await axios.post(process.env.API_URL + '/save-regimen-calendar', formData);
    } catch (e) {

    }
}

export const getCurrentWeek = async ({ commit }) => {
    try {
        const { data } = await axios.get(process.env.API_URL + '/get-current-week');
        commit(types.FETCH_USER_CALENDAR, { data })
    } catch (e) {
        commit(types.FETCH_USER_CALENDAR_FAILURE)
    }
}

export const fetchUserElement = async ({ commit }, elementId) => {
    try {
        const { data } = await axios.post(process.env.API_URL + '/get-user-element', {'element': elementId});
        commit(types.FETCH_USER_CALENDAR_ELEMENT, { data });
    } catch (e) {

    }
};



// WEBPACK FOOTER //
// ./src/store/modules/hairRegimen/actions.js